import React from 'react';
import './Error.css';

interface ErrorProps {
  message?: string;
  onRetry?: () => void;
  showRetry?: boolean;
}

const Error: React.FC<ErrorProps> = ({ 
  message = "אירעה שגיאה בטעינת הנתונים", 
  onRetry,
  showRetry = true 
}) => {
  return (
    <div className="error-container">
      <div className="error-icon">⚠️</div>
      <h3 className="error-title">שגיאה</h3>
      <p className="error-message">{message}</p>
      {showRetry && onRetry && (
        <button className="btn btn-primary error-retry-btn" onClick={onRetry}>
          נסה שוב
        </button>
      )}
    </div>
  );
};

export default Error;
